export default "__VITE_ASSET__B71fz30$__"